module.exports = __webpack_public_path__ + "img/k-12_img.2ce1a1af.png";